import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { useAppSelector } from '../../state/store';
import { getCurrentLocation, getLocationsById } from '../../state/selectors';
import { themeProps } from '../../styles/theme';
import useStyles from '../../styles';
import { fetchLocationProperties } from '../../services/apiService';

interface BannerProps {
  dueDate: string;
  targetLocations: string[];
}

// might need to remove or update when subscription changes
const bannerList: BannerProps[] = [
  {
    dueDate: '2026-06-30',
    targetLocations: [
      'Transport for London',
      '14 Pier Walk',
      '200 Buckingham Palace Rd',
      '5 Endeavour Square',
      'Palestra House',
    ],
  },
];

function SubscriptionBanner(): JSX.Element | null {
  const { classes } = useStyles();
  const routeUrl = useLocation();
  const currentLocation = useAppSelector(getCurrentLocation);
  const locationsById = useAppSelector(getLocationsById);

  const [activeBanner, setActiveBanner] = useState<BannerProps | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(false);
    const loadBanner = async () => {
      let rootLocName = locationsById.get('#')?.name ?? '';
      if (!rootLocName) {
        const res = await fetchLocationProperties('#');
        if (res.name) rootLocName = res.name;
      }
      const matchedBanner = bannerList.find(
        (bannerItem) => rootLocName && bannerItem.targetLocations.includes(rootLocName)
      );
      setActiveBanner(matchedBanner ?? null);
    };

    loadBanner();
  }, [locationsById, routeUrl, currentLocation]);

  if (!activeBanner || dismissed) {
    return null;
  }

  const overDueByDays = dayjs().diff(dayjs(activeBanner.dueDate), 'day');

  return (
    <Box className={classes.subscriptionBanner}>
      <Typography variant="body1" sx={{ fontWeight: themeProps.fontWeight.semiBold }}>
        Your organization&apos;s subscription payment is overdue by {overDueByDays} day
        {overDueByDays !== 1 ? 's' : ''}. To avoid service interruptions, please get in touch with
        your administrator to arrange payment as soon as possible.
      </Typography>

      <Button
        onClick={() => setDismissed(true)}
        variant={themeProps.btnVariant.secondary}
        size="small"
        sx={{ mt: 2 }}
      >
        Close
      </Button>
    </Box>
  );
}

export default SubscriptionBanner;
